import styled from 'styled-components';
import media from './media';


export const HeaderButton = styled.button`
background: linear-gradient(0deg, #132361 0%, #004B8D 60%) repeat scroll 0% 0% transparent;
border-radius: 0px 0px 10px 10px;
border: 1px solid #132361;
background-color:#0B2972;
font-size: 10px;
margin: -4px;
padding: 3px;
`
export const HeaderDiv = styled.div`
padding: 0px 10px;    
position: relative;
overflow: hidden;
min-height: 77px;
height: auto;
border-radius: 10px 0px 0px 10px;
background: linear-gradient(30deg, #132361 0%, #004B8D 60%) repeat scroll 0% 0% transparent;
`
export const MORSContainer = styled.div`    
${media.mobile`
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 2px;
`}    
${media.table`
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 2px;
`}

${media.desktop`
    margin-left:190px;
    margin-right:190px;
    margin-top: 2px;    
`}

${media.large`
    margin-left: 200px;
    margin-right: 200px;
    margin-top: 10px;
`}
`;

export const NavBody = styled.div`
background: none repeat scroll 0% 0% #0B2972;`


export const NavContent = styled.div`
font-size: 12px; 
font-weight: bold; 
border-bottom: 
1px solid #000; 
box-shadow: 0px 1px 0px #193D93 inset; 
padding: 8px 0px 8px 13px;`

export const NavHeader = styled.div`
border-radius: 8px 8px 0px 0px;
height:25px;
width: 100px;
padding-left:20px;
padding-top:3px
background:#0B2972;`

export const NavSpan = styled.span`
font-family: Verdana, Arial, Helvetica, sans-serif;
font-size: 11px;
font-weight: bold;
color: #FFFFFF;`

export const LoginContainer = styled.div`
background-color: #0B2972;
border-radius: 8px 8px 8px 8px;	
padding: 5px 10px 10px 1px;
`

export const SubmitBtn = styled.button`
border: 1px solid #FF9E0C;	
border-radius: 5px 5px 5px 5px;
padding: 3px 30px 3px 30px;
margin-right: 20px;
font-size: 12px;
color: #003399;
font-weight: bold;
background: linear-gradient(0deg, #FF9E0C 0%, #FFB20C 60%) repeat scroll 0% 0% transparent;
`

//Monina start - added
export const SubmitButton = styled.button`
border: 1px solid #FF9E0C;	
border-radius: 5px 5px 5px 5px;
padding: 3px 30px 3px 30px;
font-size: 12px;
color: #003399;
font-weight: bold;
background: linear-gradient(0deg, #FF9E0C 0%, #FFB20C 60%) repeat scroll 0% 0% transparent;
`
//Monina end - added

export const MidCifBtn = styled.button`
border: 1px solid #FF9E0C;	
border-radius: 5px;
padding: 5px 10px 5px 10px;

margin-left: 5px;
font-size: 12px;
color: #003399;
font-weight: bold;
background-color:#FF9E0C;
`

export const ContactContainer = styled.div`

border-radius: 8px 8px 8px 8px
padding-bottom: 12px;
`

export const FooterContainer = styled.div`
border-top: gray 1px solid;
font-size: 10px;
text-align: center;
`

export const FooterCopyright = styled.div`
padding-top:10px;
text-align: center;
color: #999;
font-size: 10px;
`
export const FooterSMDiv = styled.div`
margin-top: 20px;
background-color: #848484;
color: white;
font-size: 10px;
`

export const SubMenuDiv = styled.div`
min-height: 10px;
border-bottom: 2px #ffffff;
font-family: Verdana, Arial, Helvetica, sans-serif;
font-size: 10px;		
margin-left: 30px;
`

export const BodyHeaderDiv = styled.div`
border-radius: 6px 6px 0px 0px;
border: #0B2972 1px solid;
background-color: #0B2972;
height: 30;    
`
export const AdvisoryHeaderDiv = styled.div`
border-radius: 6px 6px 0px 0px;
border: #F5F5F5 1px solid;
background-color: #F5F5F5;
height: 30;    
`

export const BodyHeaderText = styled.span`
color: #FFFFFF;
vertical-align: middle;
line-height: 30px;
margin-left: 10px;
font-size: 12px;
font-weight: bold;    
`

export const LiboldNavyBlue = styled.span`
font-family: Verdana, Arial, Helvetica, sans-serif;
font-size: 12px;
font-weight: bold;
color: #337ab7;
`

export const AdvisoryHeaderText = styled.span`
color: #0B2972;
vertical-align: middle;
line-height: 30px;
margin-left: 10px;
font-size: 14px;    
font-weight: bold;
`



export const ContentDiv = styled.div`
border: #0B2972 1px solid;
border-radius: 0px 0px 6px 6px;
padding: 10px;
`
export const VersionText = styled.div`
color: #FFFFFF;
font-size: 15px;    
font-weight: bold;
`

export const FakeBtn = styled.span`
border: 1px solid #FF9E0C;
border-radius: 5px 5px 5px 5px;
padding: 3px 30px 3px 30px;
margin-right: 20px;
display: inline-block;
font-size: 12px;
color: #003399;
font-weight: bold;
background: linear-gradient(0deg, #FF9E0C 0%, #FFB20C 60%) repeat scroll 0% 0% transparent;
font-family: Verdana, Arial, Helvetica, sans-serif;
`

export const ViewPre = styled.pre`
font-family: Verdana, Arial, Helvetica, sans-serif;
`

export const LogOutBtn = styled.button`
border: 1px solid #FF9E0C;	
border-radius: 5px 5px 5px 5px;
padding: 3px 5px 3px 5px;
margin-right: 1px;
font-size: 12px;
color: #003399;
font-weight: bold;
background: linear-gradient(0deg, #FF9E0C 0%, #FFB20C 60%) repeat scroll 0% 0% transparent;
`

export const FooterBodyMobile = styled.div`
background-color: #848484;
color: white;
font-size: 11px;
text-align: center;
bottom: 0;
height: 25px;`

export const FooterMobile = styled.span`
border-bottom:1px solid white;
border-right:1px solid white;
text-align: center;
font-family: Verdana, Arial, Helvetica, sans-serif;
`